import React from "react";

import { graphql } from "gatsby";
import PropTypes from "prop-types";
import Col from "react-bootstrap/Col";

import RadioButtons from "../../components/localForms/radioButtons/radioButtons";
import Tooltip from "../../components/localForms/tooltip/tooltip";

const KontentItemInputTypeSalutation = (props) => {
  const {
    data,
    onChange,
    errors,
    meta,
    touched,
  } = props;

  const { elements } = data;

  const options = elements.options.value.split("\n") || [];

  return (
    <Col xs={12}>
      <Tooltip
        id={elements.id.value}
        tooltipMessage={elements.tooltip.value}
      >
        <RadioButtons
          label={elements.label.value.length > 0 ? elements.label.value : null}
          id={elements.id.value}
          options={options}
          data={data}
          onChange={onChange}
          errors={errors}
          touched={touched}
          title={elements.label.value}
          isRequired={elements.required.value.length > 0 && elements.required.value[0].codename === "id"}
          hideLabel={elements.required.value.length === 0
            && elements.hide_label.value.length > 0
            && elements.hide_label.value[0].codename === "true"}
          meta={meta}
        />
      </Tooltip>
    </Col>
  );
};

export const query = graphql`
  fragment KontentItemInputTypeSalutation on kontent_item_input_type_salutation {
    id
    elements {
      id {
        value
      }
      label {
        value
      }
      options {
        value
      }
      required {
        value {
          codename
        }
      }
      tooltip {
        value
      }
      hide_label {
        value {
          codename
        }
      }
    }
  } 
`;

KontentItemInputTypeSalutation.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
  errors: PropTypes.oneOfType([PropTypes.object]).isRequired,
  meta: PropTypes.oneOfType([PropTypes.object]).isRequired,
  onChange: PropTypes.func.isRequired,
  touched: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default KontentItemInputTypeSalutation;
